import {Accordion} from 'components/accordion';
import {AudioCollection} from 'components/stories-item/tracklist';
import {AudioPlayer} from 'components/stories-item/audioplayer';
import axios from 'axios';
import Cookie from 'components/cookie';
import CustomSelect from 'components/forms/custom-select';
import FileInput from 'components/forms/file-input';
import Form from 'components/forms';
import FullIframe from 'components/full-iframe';
import FullText from 'components/full-text';
import Header from 'components/header';
import {ImageTooltip} from 'components/tooltip';
import ImgMap from 'components/img-map';
import Menu from 'components/menu';
import MenuTrigger from 'components/menu-trigger';
import MultiSlider from 'components/multi-slider';
import Observer from 'common/scripts/observer';
import Parametric from 'components/parametric';
import {PopupFacade} from 'components/popup/popupFacade';
import Preloader from 'components/preloader';
import SalePopup from 'components/sale-buttons';
import ScrollBy from 'components/scrollBy';
import searchPanelInit from 'components/search-panel';
import Share from 'components/share';
import SliderAccent from 'components/slider-accent';
import SliderPersons from 'components/slider-persons';
import SliderThird from 'components/slider-third';
import Tabs from 'components/tabs';
import TariffsProgram from 'components/tariffs-program';
import ThemeBlocks from 'components/theme-block';
import Toggle from 'components/toggle';
import {Utils} from './utils';
import Validation from 'components/forms/validation';
import YandexMapMini from 'components/yandex-map-mini';
import YandexMapPopup from 'components/yandex-map-popup';

const validation = new Validation();
const observer = new Observer();

// Хедер
export const initHeader = (element) => {
    const targetElement = document.querySelector('.j-header__target');

    new Header().init({
        element,
        targetElement
    });
};

// Кнопка меню
export const initMenuTrigger = (wrapper) => {
    new MenuTrigger().init({wrapper});
};

// Меню
export const initMenu = (element) => {
    new Menu().init(element);
};

// Блоки тем
export const initThemeBlocks = (themeBlocks) => {
    new ThemeBlocks().init({themeBlocks});
};

export const initSingleSelect = (elem) => {
    new CustomSelect({container: elem}).init();
};

export const initMultiSelect = (elem) => {
    new CustomSelect({
        container: elem,
        template : 'radio'
    }).init();
};

// Подключение ленивой загрузки (img/picture/iframe)
export const lazyLoadElements = (lazyElements) => {
    const replaceSource = (element) => {
        const targetAttribute = element.nodeName === 'SOURCE' ? 'srcset' : 'src';
        const sourceElement = element.nodeName === 'SOURCE' ? 'data-srcset' : 'data-src';

        element.setAttribute(targetAttribute, element.getAttribute(sourceElement));
        element.removeAttribute(sourceElement);
        element.classList.add('is-loaded');
    };

    if ('IntersectionObserver' in window) {
        const lazyImageObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    const lazyEl = entry.target;

                    replaceSource(lazyEl);
                    lazyImageObserver.unobserve(lazyEl);
                }
            });
        });

        lazyElements.forEach((lazyImage) => {
            if (Utils.isInViewport(lazyImage, window.innerHeight || document.documentElement.clientHeight)) {
                replaceSource(lazyImage);
            } else {
                lazyImageObserver.observe(lazyImage);
            }
        });
    } else {
        // Not supported or native support, load all images immediately
        lazyElements.forEach((lazyEl) => {
            replaceSource(lazyEl);
        });
    }
};

// Карта из изображения
export const initImgMap = (elem) => {
    new ImgMap({
        container: elem,
        name     : elem.dataset.name
    }).init();
};

// Карусель 3-го типа
export const initSliderThird = (elem) => {
    new SliderThird({
        container: elem,
        elem     : elem.querySelector('.j-slider-third__slides'),
        controls : elem.querySelector('.j-slider-third__controls'),
        prevArrow: elem.querySelector('.j-slider__prev'),
        nextArrow: elem.querySelector('.j-slider__next'),
        counter  : elem.querySelector('.j-slider__counter'),
        settings : {
            autoplay     : true,
            autoplaySpeed: 8000,
            pauseOnHover : false,
            fade         : true,
            infinite     : true,
            speed        : 600,
            responsive   : [{
                breakpoint: 960,
                settings  : {
                    autoplay: false
                }
            }]
        }
    }).init();
};

/* eslint-disable max-lines-per-function*/
export const initMultiSliders = (item) => {
    const mobileAdaptive = item.dataset.adaptive ? Boolean(item.dataset.adaptive) : false;

    new MultiSlider({
        item,
        settings: {
            wrapperClass    : 'j-multi-slider-wrapper',
            slideClass      : 'j-multi-slider-slide',
            slideActiveClass: 'is-active',
            slidesPerView   : 'auto',
            navigation      : {
                prevEl       : '.j-multi-slider-arr__prev',
                nextEl       : '.j-multi-slider-arr__next',
                disabledClass: 'is-disabled'
            },
            pagination: {
                el               : '.j-multi-slider-pagination',
                bulletElement    : 'button',
                clickable        : true,
                bulletClass      : 'multi-slider__dot',
                bulletActiveClass: 'is-active'
            },
            breakpoints: {
                0: {
                    autoHeight: mobileAdaptive
                },
                960: {
                    autoHeight: false
                }
            },
            on: {
                // eslint-disable-next-line
                transitionStart: function() {
                    if (this.isEnd && this.slides[this.activeIndex + 1] &&
                        !this.slides[this.activeIndex + 1].classList.contains('is-active')) {
                        if (!this.slides[this.activeIndex + 1].classList.contains('is-active')) {
                            this.slides[this.activeIndex].classList.add('is-last-prev');
                            this.slides[this.activeIndex + 1].classList.add('is-last-active');
                        }
                    } else {
                        [].slice.call(this.slides).forEach((slide) => {
                            slide.classList.remove('is-last-active', 'is-last-prev');
                        });
                    }
                },
                // eslint-disable-next-line
                slideChange: function() {
                    const iframe = this.slides[this.previousIndex].querySelector('iframe');

                    if (!iframe) {
                        return;
                    }

                    if ((/youtube/).test(iframe.src) && (/enablejsapi=1/).test(iframe.src)) {
                        iframe.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
                    } else {
                        const iframeSrc = iframe.src;

                        iframe.src = iframeSrc;
                    }
                }
            }
        }
    }).init();
};
/* eslint-enable max-lines-per-function*/

export const initAccentSliders = (item) => {
    new SliderAccent(item).init();
};

export const initPersonsSliders = (item) => {
    new SliderPersons(item).init();
};

// Табы
export const initTabs = (elemItem) => {
    new Tabs().init({elem: elemItem});
};

// Якоря
export const initScrollBy = (options) => {
    new ScrollBy().init(options);
};

// Мобильные псевдопопапы акций
export const initSalePopups = (wrapper) => {
    new SalePopup().init(wrapper);
};

export const initForm = (wrapper) => {
    new Form().init({
        target             : wrapper,
        successMessage     : true,
        successFromTemplate: wrapper.dataset.successTemplate,
        successTemplateType: wrapper.dataset.successTemplate,
        successMessageTxt  : wrapper.dataset.responsemsg || false
    });
};

export const initTariffsProgram = (containers) => {
    containers.forEach((container) => {
        new TariffsProgram({container}).init();
    });
};

// Прелоадер
export const initPreloader = (options) => {
    new Preloader().init(options);
};

// Инициализация формы обратной связи
/* eslint-disable max-lines-per-function, max-statements */
export const initCallbackForm = () => {
    observer.subscribe('popup:open', (popup) => {
        if (!popup.content) {
            return;
        }

        const callbackSelector = popup.content.querySelector('.j-form');

        if (callbackSelector) {
            validation.refresh(callbackSelector);

            new Form().init({
                target             : callbackSelector,
                successMessage     : true,
                successFromTemplate: Boolean(callbackSelector.dataset.successTemplate),
                successTemplateType: callbackSelector.dataset.successTemplate || 'callbackPopup',
                popupInstance      : popup,
                successMessageTxt  : callbackSelector.dataset.responsemsg || false
            });

            observer.subscribe('successForm', () => {
                popup.popup.classList.add('popup_state_form-success');
            });

            observer.subscribe('errorForm', () => {
                popup.popup.classList.add('popup_state_form-error');
            });

            observer.subscribe('returnForm', () => {
                popup.popup.classList.remove('popup_state_form-success', 'popup_state_form-error');
            });

            const mortgageForm = callbackSelector.id === 'mortgage-callback-form';

            if (mortgageForm) {
                window.dataLayer = window.dataLayer || [];

                window.dataLayer.push({
                    event     : 'GAevent',
                    GAcategory: 'form',
                    GAaction  : 'open',
                    GAlabel   : 'mortgageapply'
                });
            }

            const mortageConsultBtn = document.querySelector('.j-mortgage-consult');

            if (mortageConsultBtn) {
                const mortageConsultForm = document.querySelector('#mortgage-callback-form form');
                const mortageCalcForm = document.querySelector('#mortgage-calc form');

                if (mortageCalcForm) {
                    const mortageConsTerm = mortageCalcForm.querySelector('[name="term"]').getAttribute('value');
                    const mortageConsPay = mortageCalcForm.querySelector('[name="pay"]').getAttribute('value');
                    // eslint-disable-next-line max-len
                    const mortageConsType = mortageCalcForm.querySelector('[class^="select__fake-current-text"]').textContent;

                    // eslint-disable-next-line max-len
                    mortageConsultForm.insertAdjacentHTML('afterbegin', `<input class="j-mortgage-consult-pay" name="pay" type="hidden" value="${mortageConsPay}">`);
                    // eslint-disable-next-line max-len
                    mortageConsultForm.insertAdjacentHTML('afterbegin', `<input class="j-mortgage-consult-tabs" name="tabs" type="hidden" value="${mortageConsType}">`);
                    mortageConsultForm.querySelector('[name="term"]').setAttribute('value', mortageConsTerm);
                }
            }
        }
    });
};
/* eslint-enable max-lines-per-function, max-statements */
export const initPopup = (buttons, otherOptions = {}) => {
    const options = {
        ...{openButtons: buttons},
        ...otherOptions
    };

    new PopupFacade(options).init();
};

export const initCallbackPopup = (buttons) => {
    const options = {
        removeDelay         : 300,
        closeButtonAriaLabel: 'Закрыть форму обратного звонка'
    };

    initCallbackForm();
    initPopup(buttons, options);
};

export const initParametricCallbackPopups = (buttons) => {
    const options = {
        removeDelay         : 300,
        closeButtonAriaLabel: 'Закрыть форму обратного звонка'
    };

    initPopup(buttons, options);
};

export const initAccordions = (elem) => {
    new Accordion().init({
        elem,
        selectors: {
            toggler     : '.j-accordion-header',
            content     : '.j-accordion-content',
            contentOuter: '.j-accordion-content-outer',
            title       : '.j-accordion-title'
        }
    });
};

export const yandexMapPopup = (container, target) => {
    new YandexMapPopup({
        container,
        target
    }).init();
};

export const initFullIframe = (target) => {
    new FullIframe({target}).init();
};

export const yandexMapMini = (container) => {
    new YandexMapMini({container}).init();
};

export const initHorizontalMenu = (menu) => {
    const activeItem = menu.querySelector('.is-active');

    if (!activeItem) {
        return;
    }

    const scrollToActiveItem = () => {
        const menuPadding = parseInt(window.getComputedStyle(menu).getPropertyValue('padding-left'), 10);

        menu.scrollTo({
            left    : activeItem.offsetLeft - menuPadding,
            behavior: 'smooth'
        });
    };

    scrollToActiveItem();

    window.addEventListener('orientationchange', () => {
        setTimeout(scrollToActiveItem, 0);
    });
};

// Панель поиска
export const initSearchPanel = (options) => {
    searchPanelInit(options);
};

// Параметрический
export const initParametric = (options) => {
    new Parametric(options).init();
};

// Тултипы на изображениях
export const initImageTooltip = (elem) => {
    new ImageTooltip().init({
        target         : elem,
        type           : 'image',
        mobileContainer: elem.closest('.j-img-pins')
    });
};

// Блок поделиться
export const initShare = (element) => {
    new Share(element).init();
};

// Блок о cookies
export const initCookie = () => {
    new Cookie().init();
};

// Навешивание целей на форму при появлении ее в области видимости
export const intersectingEvents = (target) => {
    if ('IntersectionObserver' in window) {
        const eventObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    window.dataLayer.push({
                        event     : 'GAevent',
                        GAcategory: 'form',
                        GAaction  : 'open',
                        GAlabel   : 'Лендинг для RBI OK'
                    });

                    eventObserver.unobserve(target);
                }
            });
        });

        eventObserver.observe(target);
    }
};

export const splitValue = (values) => {
    const isMobile = Utils.isBreakpoint(320, 959);

    for (const value of values) {
        value.innerHTML = value.innerHTML.split(',').join(',<br>');
    }

    if (!isMobile) {
        for (const value of values) {
            value.innerHTML = value.innerHTML.split('-').join('-<br>');
        }
    }
};

export const initFullText = (element) => {
    new FullText({element}).init();
};

// Инитим встроенный визуальный только для десктопа
export const initInnerVisual = (element) => {
    if (!Utils.isMobile() && !element.src && element.dataset.src) {
        element.src = element.dataset.src;
    }
};

// Инитим встроенный визуальный только для десктопа
export const initStepSubscribe = (element) => {
    // eslint-disable-next-line no-use-before-define
    window.addEventListener('message', (event) => {
        let message = 'дом на плане комплекса';

        if (event.data.message && event.origin.indexOf('rbi') > -1) {
            switch (event.data.message) {
                case 'building':
                    message = 'дом на плане комплекса';
                    break;
                case 'section':
                    message = 'секцию на плане комплекса';
                    break;
                case 'floor':
                    message = 'этаж на плане корпуса';
                    break;
                case 'flat':
                    if (event.origin.indexOf('artstudio') > -1) {
                        message = 'апартаменты на плане этажа';
                    } else {
                        message = 'квартиру на плане этажа';
                    }
                    break;
                default:
                    message = 'дом на плане комплекса';
            }
            element.innerText = message;
        }
    }, false);
};

// шаг назад по истории
export const historyStepBack = (elem) => {
    // eslint-disable-next-line consistent-return
    elem.addEventListener('click', (event) => {
        event.preventDefault();
        if (history.length === 1 || document.referrer.indexOf('rbi.ru') === -1) {
            if (window.location.href.includes('news')) {
                window.location.href = '//www.rbi.ru/about/news/';
            } else if (window.location.href.includes('articles')) {
                window.location.href = '//www.rbi.ru/articles/';
            } else {
                window.location.href = '//www.rbi.ru';
            }
        } else {
            history.back();
        }
    });
};

// автоматически растягивающаяся при наборе текста textarea
export const autoresizeTextarea = () => {
    const txs = document.querySelectorAll('.j-stretching-textarea');

    txs.forEach((element) => {
        const offset = element.offsetHeight - element.clientHeight;

        element.addEventListener('input', (event) => {
            event.target.style.height = 'auto';
            event.target.style.height = `${event.target.scrollHeight + offset}px`;
        });
    });
};

autoresizeTextarea();

export const audioPlayersInit = (players) => {
    const allPlayers = [];

    players.forEach((player) => {
        const audioPlayer = new AudioPlayer(player);

        allPlayers.push(audioPlayer);
    });

    allPlayers.forEach((player) => {
        player.init(allPlayers);
    });
};

export const audioCollectionInit = (wrappers) => {
    wrappers.forEach((item) => {
        new AudioCollection(item).init();
    });
};

export const initFlatFrameRequest = (id) => {
    axios.get(`http://localhost/vvvv?${id}`);
};

export const initLayoutLink = (linkElement) => {
    const backLink = Utils.getUrlParams('backLink');

    if (backLink) {
        linkElement.setAttribute('href', backLink);
    } else {
        linkElement.addEventListener('click', () => {
            history.back();
        });
    }
};

export const initHybrid = () => {
    if (window.location.pathname.includes('kvartira-')) {
        window._txq.push(['track', 'view_content']);
    }

    const phoneButtons = document.querySelectorAll('.j-hybrid-phone');
    const bookButtons = document.querySelectorAll('.j-hybrid-book');
    const chooseButtons = document.querySelectorAll('.j-hybrid-choose');
    const buyButtons = document.querySelectorAll('.j-hybrid-buy');
    const bellButtons = document.querySelectorAll('.j-hybrid-bell');
    // const applicationButtons = document.querySelectorAll('.j-hybrid-application');

    if (phoneButtons.length > 0) {
        phoneButtons.forEach((button) => {
            button.addEventListener('click', () => {
                window._txq.push(['track', 'telephone']);
            })
        });
    }

    if (bookButtons.length > 0) {
        bookButtons.forEach((button) => {
            button.addEventListener('click', () => {
                window._txq.push(['track', 'book']);
            })
        });
    }

    // НОВОЕ
    if (chooseButtons.length > 0) {
        chooseButtons.forEach((button) => {
            button.addEventListener('click', () => {
                window._txq.push(['track', 'choose_a_property']);
                console.log('hybrid: click choose');
            })
        });
    }

    if (buyButtons.length > 0) {
        buyButtons.forEach((button) => {
            button.addEventListener('click', () => {
                window._txq.push(['track', 'How_to_buy']);
                console.log('hybrid: click how buy');
            })
        });
    }

    /* if (applicationButtons.length > 0) {
        applicationButtons.forEach((button) => {
            button.addEventListener('click', () => {
                window._txq.push(['track', 'application']);
            })
        });
    } */

    if (bellButtons.length > 0) {
        bellButtons.forEach((button) => {
            button.addEventListener('click', () => {
                window._txq.push(['track', 'the bell']);
                console.log('hybrid: click bell');
            })
        });
    }
}

// Инициализация инпутов для загрузки файлов
export const initFileInput = (wrappers) => {
    wrappers.forEach((wrapper) => {
        new FileInput({wrapper}).init();
    });
}

// Дефолтные туглеры
export const initToggle = (container) => {
    new Toggle(container);
};

// Форма подписки за скидку - с проверкой сессии и кук
export const initDiscountForm = () => {
    const delay = 60000;
    // 12 часов между показами кук - в миллисекундах
    const delta = 1000 * 60 * 60 * 12;
    const discountPopup = document.querySelector('.j-discount-popup');
    const discountBtn = document.querySelector('.j-discount-btn');

    const getCookie = (name) => {
        return document.cookie.includes(name);
    }

    if (!discountBtn || !discountPopup) {
        return;
    }

    // проверяем, показывали форму за последние 12 часов или нет и подписывался ли юзер
    if (!getCookie('subscriptionShown') && !getCookie('subscribed')) {
        // через минуту эмулируем клик, чтобы открылся попап
        setTimeout(() => {
            discountBtn.click();

            const date = new Date();

            date.setTime(date.getTime() + delta);

            cookieStore.set({
                name: 'subscriptionShown',
                value: true,
                expires: date,
                path: '/',
                domain: 'rbi.ru'
            });
        }, delay);
    }
};
